var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 0H4.16667C1.86917 0 0 1.86917 0 4.16667V15.8333C0 18.1308 1.86917 20 4.16667 20H15.8333C18.1308 20 20 18.1308 20 15.8333V4.16667C20 1.86917 18.1308 0 15.8333 0ZM14.1667 8.33333C14.1667 10.345 12.7325 12.0242 10.8333 12.4125V15H12.5C12.96 15 13.3333 15.3733 13.3333 15.8333C13.3333 16.2933 12.96 16.6667 12.5 16.6667H7.5C7.04 16.6667 6.66667 16.2933 6.66667 15.8333C6.66667 15.3733 7.04 15 7.5 15H9.16667V12.3958C7.2225 11.9892 5.83333 10.1775 5.83333 8.1475V5C5.83333 4.07917 6.57917 3.33333 7.5 3.33333H8.98583C8.98583 3.33333 7.57833 5.69833 7.55833 5.76417C7.43583 6.17 7.5125 6.615 7.76583 6.95583C8.01917 7.29667 8.4225 7.5 8.84667 7.5H10.57L9.2925 9.56083C9.05 9.95167 9.17083 10.4658 9.56167 10.7083C9.69833 10.7933 9.85 10.8333 10 10.8333C10.2783 10.8333 10.5517 10.6933 10.7092 10.4392L12.2767 7.90833C12.5492 7.4975 12.5742 6.9725 12.3408 6.5375C12.1075 6.1025 11.6567 5.8325 11.1633 5.8325H9.43083L10.9292 3.3325H12.5C13.4208 3.3325 14.1667 4.07833 14.1667 4.99917V8.3325V8.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.75abdeff1d1f984152b453ec0889eea5.svg";
export { ForwardRef as ReactComponent };